import React from 'react';

import type { SelectorExtras } from '@rover/react-lib/src/components/utils/Redux';
import { Connect } from '@rover/react-lib/src/components/utils/Redux';
import { ELIGIBLE_COUNTRIES } from '@rover/react-lib/src/pages/bright-horizons-checkout/components/BHHowToPay/constants';
import { selectors as countryConfigurationSelectors } from '@rover/react-lib/src/redux/ducks/countryConfiguration.duck';
import { selectors as currentUserSelectors } from '@rover/react-lib/src/redux/ducks/currentUser.duck';
import { selectors as frontendConfigurationSelectors } from '@rover/react-lib/src/redux/ducks/frontendConfiguration.duck';
import {
  effects as searchEffects,
  selectors as searchSelectors,
} from '@rover/react-lib/src/redux/ducks/search.duck';

import { selectors as searchFiltersSelectors } from '../../SearchFilters.duck';
import { actions as searchMapActions, selectors as searchMapSelectors } from '../../SearchMap.duck';

import SearchResults from './SearchResults';

type Props = {
  searchCardRefs?: (instance: HTMLDivElement, index: number) => void;
  isSeoPage: boolean;
};
const effects = {
  onFavoriteToggled: searchEffects.toggleFavorite,
};
const actions = {
  onResultCardMouseEnter: searchMapActions.resultCardHovered,
  onResultCardMouseLeave: searchMapActions.resultCardHoveredOut,
};

const selector = (state, { resolveApiError }: SelectorExtras) => {
  const countryCode = searchSelectors.getSearchCountryCode(state);
  const isNonEligibleCountry = !!countryCode && !ELIGIBLE_COUNTRIES.includes(countryCode);
  return {
    alternateSearchResults: searchSelectors.getAlternateSearchResults(state),
    alternateServiceName: searchSelectors.getAlternateServiceName(state),
    alternateServiceDescription: searchSelectors.getAlternateServiceDescription(state),
    bookingFeePercentage:
      countryConfigurationSelectors.getCurrentCountryPrintableBookingFeePercentage(state),
    bookingFeeCap: countryConfigurationSelectors.getCurrentCountryPrintableBookingFeeCap(state),
    countryConfigUrls: countryConfigurationSelectors.getCurrentCountryUrls(state),
    currentFilters: searchFiltersSelectors.getFilters(state),
    didFiltersChangeSincePageLoad: searchFiltersSelectors.getDidFiltersChangeSincePageLoad(state),
    hoveringResultIndex: searchMapSelectors.getHoveringResultIndex(state),
    isAuthenticated: currentUserSelectors.isAuthenticated(state),
    isMapExpanded: searchMapSelectors.getIsExpanded(state),
    locale: frontendConfigurationSelectors.getLanguage(state),
    memberProfileLinkParams: searchFiltersSelectors.getMemberProfileLinkParams(state),
    priceTransparencyLevel: searchSelectors.getPriceTransparencyLevel(state),
    searchErrorMessage: resolveApiError(searchSelectors.getSearchErrorMessage(state)),
    searchResults: searchSelectors.getSearchResults(state),
    searchUuid: searchSelectors.getSearchUuid(state),
    searchCallouts: searchSelectors.getSearchCallouts(state),
    searchResponseNumberOfResults: searchSelectors.getSearchResponseTotalNumberOfResults(state),
    preferCatReviews: searchSelectors.getShouldPreferCatReviews(state),
    selectedProviderResult: searchSelectors.getSelectedProvider(state),
    searchQueryDates: searchSelectors.getQueryDateRange(state),
    searchQueryDistinctDates: searchSelectors.getQueryDistinctDates(state),
    isShowingPriceInCurrency:
      isNonEligibleCountry || searchSelectors.getIsShowingPriceInCurrency(state),
    cardTreatment: searchSelectors.getCardTreatment(state),
    introVideoDisplayEnabled: searchSelectors.getIntroVideoDisplayEnabled(state),
    cbsa: searchSelectors.getCbsa(state),
  };
};

const SearchResultsContainer = (props: Props): JSX.Element => (
  <Connect selector={selector} effects={effects} actions={actions}>
    {(connectedProps) => <SearchResults {...connectedProps} {...props} />}
  </Connect>
);

export default SearchResultsContainer;
